import { ReactElement } from 'react';

import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import styles from './error-not-found.module.scss';

import { Text, Button } from 'views/components';

export const ErrorNotFound = (): ReactElement => {
  const history = useHistory();

  return (
    <div className={styles.error}>
      <p className={styles.code}>404</p>
      <Text>
        <FormattedMessage id="notfound.message" />
      </Text>
      <Button onClick={() => history.goBack()}>
        <FormattedMessage id="notfound.action" />
      </Button>
    </div>
  );
};
